import { all, call } from 'redux-saga/effects';

import navigationSaga from './navigation';
import home from './home';
import post from './post';
import auth from './auth';
import siteInfo from './siteInfo';
import error from './error';
import googleTagManager from './googleTagManager';
import campaign from './campaign';
import profile from './profile';
import dashboard from './dashboard';
import accomplishment from './accomplishment';
import scoreRecord from './scoreRecord';
import tutorDashboard from './tutorDashboard';
import header from './header';
import practice from './practice';

/**
 * @param {Object} [context]
 *
 * Shape of context object:
 *
 *  { history } ---> react router history object
 *
 * History object from react router v4 provide us way to redirect
 * outside of react context. The purpose is to extract redirect logic
 * away from component.
 */
export default function* root(context) {
  yield all([
    call(navigationSaga, context),
    call(home),
    call(post),
    call(auth),
    call(siteInfo),
    call(error),
    call(googleTagManager),
    call(campaign),
    call(profile),
    call(dashboard),
    call(accomplishment),
    call(scoreRecord),
    call(tutorDashboard),
    call(header),
    call(practice),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/index.js